import IntroductionAlt from "./IntroductionAlt";
export default IntroductionAlt;